module.exports = __webpack_public_path__ + "img/Mastercard.1eb906a4.svg";